import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import {
   ReceptionServiceForPractitionerSimple,
   ReceptionServiceForPractitionerSimpleQuery,
} from '@dreryk/egabinet-private-medical-service-frontend-api';
import { CurrentHealthcareProviderPaymentsConfigurationEnabledQuery } from '@dreryk/egabinet-online-payments-integration-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import { useCqrsFind, useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../translations';

type ReceptionServiceInteractiveTableLoaderRenderProps = {
   receptionServices: ReceptionServiceForPractitionerSimple[];
   onlinePaymentsIntegrationExists: boolean;
};

type ReceptionServiceInteractiveTableLoaderProps = {
   readonly practitionerId: PractitionerId;
   readonly children: (props: ReceptionServiceInteractiveTableLoaderRenderProps) => JSX.Element;
};

export const ReceptionServiceInteractiveTableLoader = (
   props: ReceptionServiceInteractiveTableLoaderProps
): JSX.Element | null => {
   const {
      data: receptionServices,
      loading: receptionServicesLoading,
      error: receptionServicesError,
   } = useCqrsSearch<ReceptionServiceForPractitionerSimple>(() => {
      const query = new ReceptionServiceForPractitionerSimpleQuery();
      query.practitionerId = props.practitionerId.asNumber();
      return query;
   });

   const {
      data: onlinePaymentsIntegrationExists,
      loading: onlinePaymentsIntegrationExistsLoading,
      error: onlinePaymentsIntegrationExistsError,
   } = useCqrsFind(() => new CurrentHealthcareProviderPaymentsConfigurationEnabledQuery(), { enabled: !isDemo() });

   if (receptionServicesLoading || onlinePaymentsIntegrationExistsLoading) {
      return <LoaderSpinner />;
   }

   if (receptionServicesError || onlinePaymentsIntegrationExistsError) {
      return (
         <Message
            testId={'receptionServiceTableLoaderError'}
            type={MessageType.NEGATIVE}
            label={receptionServiceTranslationKeys.extensions.calendar.appointment.table.errors.loadData}
            displayIndicator
         />
      );
   }

   return props.children({
      receptionServices: receptionServices,
      onlinePaymentsIntegrationExists: Boolean(onlinePaymentsIntegrationExists) ?? false,
   });
};
